const Shimmer = ({ height = "20px", width = "100%", borderRadius = "4px" }) => (
  <div
    style={{
      height,
      width,
      borderRadius,
      background: "linear-gradient(90deg, #f3f3f3, #e0e0e0, #f3f3f3)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
    }}
  />
);

const shimmerStyle = `
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
  `;

export const ShimmerWrapper = () => <style>{shimmerStyle}</style>;

export default Shimmer;
